import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import CrimeGameContainer from '../components/crime-game/CrimeGameContainer';
import { LoginPrompt } from '../components/LoginPrompt';
import { Search } from 'lucide-react';

export default function CrimeGame() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600" />
      </div>
    );
  }

  if (!currentUser) {
    return (
      <LoginPrompt
        title="Login Required to Solve Mysteries"
        description="You need to be logged in to play Crime of the Day and solve mysteries. Create an account or login to start your detective journey!"
        featureName="Crime Game"
        icon={<Search className="w-10 h-10 text-purple-600" />}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <CrimeGameContainer />
    </div>
  );
}
